// pageContent Copyright 2022 Rebecca L Beaudet
import { EMAIL, FOUNDER, CREDENTIALS, founderHeadshot, CORP_NAME, ONLINE_LEARNING_ROUTE, headShotAltText, RATE_GROUP, } from './constantContent';
const featuretteItems = [
    {
        heading: 'Mission',
        muted: 'Compassionate Collaboration',
        placeholder: 'Building relationships to empower every learner.',
        img: '/img/2025_logo.jpg',
        descImg: 'Cute blob faces and list of principles',
    },
    {
        heading: 'Our Staff',
        muted: 'Cares',
        placeholder: `Founded by ${FOUNDER}, ${CREDENTIALS}`,
        img: founderHeadshot,
        descImg: headShotAltText,
    },
];
const carouselItems = [
    {
        title: CORP_NAME,
        placeholder: `Helping youth discover autonomy and authenticity.`,
    },
    {
        title: 'Compassion',
        placeholder: `Using a strengths-based and neurodiversity affirming approach.`,
    },
    {
        title: 'Co-Regulation',
        placeholder: `Supporting sensory needs to better access learning in all domains.`,
    },
    {
        title: 'Connection',
        placeholder: `Safety, engagement, and relationship with others provide greater learning outcomes.`,
    },
    {
        title: 'Communication',
        placeholder: `Validating all methods of communicating and promoting self-advocacy.`,
    },
    {
        title: 'Collaboration',
        placeholder: `We are better together.`,
    },
];
const otherNavLinks = [
    { name: 'Learning Portal', path: ONLINE_LEARNING_ROUTE },
];
const scheduleDiscovery = `Email us today to schedule your free 15-minute discovery call.`;
const navPages = [
    {
        path: 'about',
        navName: 'About',
        header: `About ${CORP_NAME}`,
        sections: [
            {
                paragraph: `${CORP_NAME} offers various services to families and providers supporting children of all abilities and neurotypes. 
        These include educational consultations, portfolio reviews (for New Hampshire homeschool families), online learning, and virtual and in-person meet-up groups. 
        The five pillars: compassion, co-regulation, connection, communication, and collaboration guide these services.`,
            },
        ],
        listGroup: {
            heading: 'Learn More',
            group: [
                { title: 'Meet the Staff', path: 'staff' },
                { title: 'Contact Us', path: 'contact' },
            ],
        },
    },
    {
        path: 'families',
        navName: 'For Families',
        header: `For Families`,
        img: '/img/Parent_and_Caregiver_Group.jpg',
        imgAltTxt: `A square image with watercolor rainbows on the top 
      and bottom and a black silhouette of a family of four holding hands in the center.`,
        sections: [
            {
                paragraph: `${CORP_NAME} provides various services to support families and children of all abilities and neurotypes. 
        The five pillars—compassion, co-regulation, connection, communication, and collaboration—guide these services. 
        Current services offered include educational consultations, portfolio reviews, online learning, and virtual and in-person meet-up groups. `,
            },
            {
                paragraph: `Contact ${CORP_NAME} today.`,
            },
        ],
        email: EMAIL,
        listGroup: {
            heading: 'Services Links',
            group: [
                // { title: 'Parent and Caregiver Virtual Meet-Up Group', path: 'meetup' },
                // {
                //   title: 'Evaluation & IEP Advocacy',
                //   path: 'advocacy',
                // },
                { title: 'Portfolio Reviews', path: 'portfolio' },
                { title: 'Educational Consultations', path: 'consults' },
                { title: 'TWIGS Forest Meet-Up', path: 'twigs' },
                { title: 'Online Learning Portal', path: 'learn' },
            ],
        },
    },
    {
        path: 'providers',
        navName: 'For Providers',
        img: '/img/Workshops.jpg',
        imgAltTxt: `A square image with watercolor rainbows on the top and bottom and a black outline of notebook and pencil`,
        header: `For Providers`,
        sections: [
            {
                paragraph: `${CORP_NAME} provides a variety of services to support providers from multiple disciplines 
        as well as their students or clients of varying abilities and neurotypes. 
        The five pillars: compassion, co-regulation, connection, communication, and collaboration guide these services.
        Promoting autonomy and authenticity for all children through compassionate collaboration is our goal.`,
            },
            {
                paragraph: `Contact ${CORP_NAME} today.`,
            },
        ],
        email: EMAIL,
        listGroup: {
            heading: 'Service Links',
            group: [
                { title: 'Mentorship', path: 'mentorship' },
                { title: 'Workshops', path: 'workshops' },
                { title: 'Online Learning Portal', path: 'learn' },
            ],
        },
    },
];
const pageContent = [
    {
        path: 'contact',
        navName: 'Contact',
        header: 'Contact',
        sections: [
            {
                paragraph: `${CORP_NAME} offers services to families and providers supporting
        youth of all abilities and neurotypes.`,
            },
            {
                paragraph: scheduleDiscovery,
            },
        ],
        email: EMAIL,
    },
    {
        path: 'staff',
        navName: 'Staff',
        header: `Meet the Staff`,
        sections: [
            {
                paragraph: `After working with children and families for a decade in public school, home, and clinic-based settings, ${FOUNDER} founded ${CORP_NAME}. 
        She is a certified teacher and worked as a special education advocate from 2022 to 2024.  
        Since becoming a mother in May 2023 and traveling full-time for the first half of 2024, she now refers to herself as a “stay-outside Mom”. 
        Rebecca has a passion for collaborating with people. 
        She wants to amplify marginalized voices. Her services focus on the social model of disability and promote neurodiversity and trauma-informed practices.  
        When Rebecca is not collaborating with ${CORP_NAME} she can be found exploring the trails or camping throughout the United States. 
        Rebecca’s educational philosophy centers around an individual’s strengths and interests, authentic connections, community, nature, travel, play, and a deep love for what you are learning.  
        She is grateful to support other families and providers. `,
            },
        ],
        accordions: {
            heading: 'Credentials',
            group: [
                {
                    title: 'Degrees',
                    list: [
                        'B.S. in Education',
                        'B.A. in Sociology',
                        'M.Ed. in Early Childhood Education: Special Needs',
                    ],
                },
                {
                    title: 'Graduate Certificates',
                    list: ['Assistive Technology', 'Applied Behavior Analysis'],
                },
                {
                    title: 'Certifications',
                    list: [
                        'Early Childhood Education',
                        'Early Childhood Special Education',
                        'Special Education',
                    ],
                },
                {
                    title: 'Specialized Training',
                    list: [
                        'Gestalt Language Processors',
                        'Introduction to DIRFloortime',
                        'SCERTS Model',
                        'Wrights Law',
                    ],
                },
            ],
        },
        img: founderHeadshot,
        imgAltTxt: headShotAltText,
    },
    // {
    //   path: 'meetup',
    //   navName: 'Meet-Up',
    //   header: 'Parent & Caregiver Meet-Up',
    //   sections: [
    //     {
    //       paragraph: `This virtual group is for parents and caregivers of neurodivergent, disabled, and/or medically complex children.
    //       Each week members share celebrations, challenges, support, and strategies together.
    //       One time per month a special guest joins to present on a topic that the group has expressed interest in.
    //       Past presentations have included topics such as AAC devices, gestalt language processors, play, stimming and sensory regulation,
    //       and Acceptance and Commitment Training.
    //       The group meets every Thursday at 9:30 a.m. Eastern Time for 1 hour.
    //       `,
    //     },
    //     {
    //       paragraph: `The link below is a monthly subscription to the group, first month is free! Join us today.`,
    //     },
    //   ],
    //   img: '/img/Parent_and_Caregiver_Group.jpg',
    //   imgAltTxt:
    //     'A square image with watercolor rainbows on the top and bottom and a black silhouette of a family of four holding hands in the center.',
    //   accordions: {
    //     heading: 'Community Standards',
    //     group: [
    //       {
    //         title: 'Acceptance',
    //         content:
    //           'We welcome everyone here regardless of sex, race, ethnicity, ability, age, orientation, or religion.',
    //       },
    //       {
    //         title: 'Support',
    //         content: `Our goal is to offer community, guidance, love, friendship, and
    //           solidarity to one another through the greatest celebrations and the most challenging of moments.`,
    //       },
    //       {
    //         title: 'Growth',
    //         content: `We aim to be better each day for ourselves, our families, and our communities.`,
    //       },
    //       {
    //         title: 'Respect',
    //         content:
    //           'We value the unique differences of one another and see the strengths in our differences.',
    //       },
    //       {
    //         title: 'Pride',
    //         content: `We are proud of ourselves, our families, and our communities.
    //           We are proud of who each of us is and what each of us has to offer to one another.`,
    //       },
    //     ],
    //   },
    //   link: `https://buy.stripe.com/3csdQTaUa6XVeUU9AN`,
    //   linkText: `Register Here`,
    // },
    {
        path: 'workshops',
        navName: 'Workshops',
        header: `Workshops`,
        sections: [
            {
                paragraph: `${CORP_NAME} teaches ways to support your neurodivergent students. 
        Learn how to implement neurodiversity affirming practices in your classroom or therapeutic setting. 
        Write goals and use assessment tools that focus on strengths instead of deficits. 
        Support children using accommodations and environmental modifications. 
        Communicate and coordinate more effectively with families and colleagues. 
        We provide 2 to 4 hour workshops both in-person and virtually on a variety of topics to support your team.`,
            },
            {
                paragraph: scheduleDiscovery,
            },
        ],
        listGroup: {
            heading: 'Rates and Topics',
            group: [
                { title: `In-Person: $250 per hour` },
                { title: `Virtual: $170 per hour` },
                { title: 'Supporting Neurodivergent Learners' },
                { title: 'Navigating the IEP Process' },
                { title: 'Explaining Autism to Children' },
                { title: 'Supporting Regulation' },
            ],
        },
        email: EMAIL,
    },
    {
        path: 'portfolio',
        navName: 'Portfolio Reviews',
        header: `Portfolio Reviews for New Hampshire Homeschool Families`,
        sections: [
            {
                paragraph: `The portfolio review process with Rebecca includes a 45-minute appointment, additional resources, and a signed letter for your records. 
 The appointment will include a brief overview of your child’s portfolio, reading list, and a description of their growth this school year. 
 If possible, the child will participate in the appointment, too. All appointments are remote. 
 Due to family scheduling restrictions and added costs, we do not currently offer in-person appointments.`,
            },
            {
                paragraph: scheduleDiscovery,
            },
        ],
        listGroup: {
            heading: 'Rates',
            group: [
                { title: `$97 for the first child (Remote)` },
                { title: `$77 for each additional child (Remote)` },
            ],
        },
        email: EMAIL,
    },
    {
        path: 'consults',
        navName: 'Consults',
        header: `Educational Consultations`,
        sections: [
            {
                paragraph: `The educational consultation process with Rebecca includes a 45-minute appointment with written recommendations and resources. 
        This is essentially a conversation where you can ask for support on education and child development topics such as neurodiversity, accommodations, enrichment activities, curriculum, nature learning, play-based learning, communication, co-regulation, and more!`,
            },
            {
                paragraph: scheduleDiscovery,
            },
        ],
        listGroup: {
            heading: 'Rate',
            group: [{ title: `$87 per appointment` }],
        },
        email: EMAIL,
    },
    {
        path: 'twigs',
        navName: 'TWIGS',
        header: `TWIGS: Together Wandering In Green Spaces Forest Meet-Up`,
        sections: [
            {
                paragraph: `TWIGS is a southern New Hampshire-based, all-season, all-weather, free outdoor meet-up for children ages birth through 8. 
        It is a child-led experience with minimal adult guidance. The group supports children, parents, and caregivers in getting outdoors and learning through nature play.
         The group meets every Tuesday from 10:00 a.m. to 2:00 p.m. For more information, please visit our group using the link below.`,
            },
        ],
        listGroup: {
            heading: 'Rate',
            group: [{ title: `Free` }],
        },
        linkText: 'TWIGS Facebook Group',
        link: 'https://www.facebook.com/share/188iKrPBss/',
    },
    // {
    //   path: 'advocacy',
    //   navName: 'Evaluation & IEP Advocacy',
    //   header: `Evaluation & IEP Advocacy`,
    //   sections: [
    //     {
    //       paragraph: `Advocacy services help parents and caregivers feel more empowered at special education meetings.
    //       ${FOUNDER} will support families before meetings by collaborating to prepare written requests and agenda topics.
    //       As your advocate she will take notes so you can focus your attention on the team discussions with school providers.
    //       The family and Rebecca will review all meeting paperwork and determine effective next steps as a team.
    //       Individual goals and priorities for your child's educational experience provides guidance through each step.
    //       Rebecca will find common language to connect parents and caregivers as well as school providers.
    //       With ${FOUNDER}'s rich experience in special education she will help you navigate the process confidently.`,
    //     },
    //     {
    //       paragraph: scheduleDiscovery,
    //     },
    //   ],
    //   email: EMAIL,
    //   listGroup: RATE_GROUP,
    // },
    {
        path: 'mentorship',
        navName: 'Mentorship',
        header: `Mentorship`,
        sections: [
            {
                paragraph: `${CORP_NAME} offers one-on-one mentorship with founder ${FOUNDER}. 
        Rebecca shares her passion and knowledge about neurodiversity affirming care 
        as well as strengths and connection-based, child-led approaches. 
        Rebecca brings a diverse perspective to her collaboration with others, 
        melding pedagogy and science from early childhood education, special education, and applied behavior analysis. 
        She has supported youth ages birth to 16 in a variety of settings. 
        Contact us if you are looking for new ideas and strategies for assessment, 
        goal writing, therapy activities, and supports for all domains.`,
            },
            {
                paragraph: scheduleDiscovery,
            },
        ],
        email: EMAIL,
        listGroup: RATE_GROUP,
    },
];
export { featuretteItems, carouselItems, otherNavLinks, pageContent, navPages };
